import React from 'react';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

export const Dates = () => (
  <div>
  <Helmet>
    <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Dates</title>
    <meta name="description" content="Important Dates" />
    <meta name="keywords" content="dates, scds2021, uitm, aaec, shah alam, conference" />
  </Helmet>
     <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Important Dates</li>
      </ol>
    </nav>
    <h2>Important Dates</h2>
    <p>
      1.	Final paper submission deadline: 31st July 2021 <br/>
      2.	Notification of paper acceptance deadline: 22nd August 2021 <br/>
      3.	Submission of 'Camera-Ready' paper and 'Copyright' form deadline: 7th September 2021 <br/>
      4.	Registration deadline: 7th September 2021 <br/>
      5.	Conference dates: 2- 3rd November 2021 <br/>
    </p>
  </div>
)